export default "__VITE_ASSET__a91174a3__"